<template>
  <div>
    <div>
      <img
        width="200px"
        :src="this.$props.logo"
        :style="cursorStyle"
        :alt="((this.$store.company && this.$store.company.name) || 'Company') + ' Logo'"
        @error="imageAltUrl"
        @click="clickedLogo"
      >
    </div>
    <h1
      class="sn-h1 sn-text-primary"
      data-cy="hero-text-title"
    >
      {{ title }}
    </h1>
    <div
      :style="`border-left: 4px solid ${this.$vuetify.theme.themes.light.primary}`"
      class="subtitle sn-subtitle-1 sn-font-weight-regular sn-text-primary-04 link-text-color"
      data-cy="hero-text-subtitle"
      v-html="subtitle"
    />
  </div>
</template>

<script>
export default {
  name: 'HeroText',
  props: {
    logo: {
      type: String,
      required: false,
      default: () => { return undefined }
    },
    title: {
      type: String,
      required: false,
      default: ''
    },
    subtitle: {
      type: String,
      required: false,
      default: ''
    },
    website: {
      type: String,
      required: false,
      default: ''
    }
  },
  computed: {
    cursorStyle () {
      return { cursor: this.website ? 'pointer' : 'default' }
    }
  },
  methods: {
    imageAltUrl (event) {
      event.target.src = '/assets/new_home_page/simplenexus-logo-with-slogan.png'
    },
    clickedLogo () {
      if (this.website) {
        window.location.href = this.website
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~/assets/css/snui";
.subtitle {
  padding-left: 12px;
  margin-top: 16px;
  margin-bottom: 40px;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.link-text-color {
  ::v-deep {
    a {
      color: $sn-primary-03 !important;
    }
  }
}
</style>
